export enum DotsButtonVariant {
  Primary = "primary",
  Transparent = "transparent",
}
